"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findParticipantsWithMultipleLessonsInSameTime = exports.participantHasLesson = exports.mergeDuplicateParticipantsInLessons = exports.getDefaultParticipant = exports.getDefaultParticipantLean = exports.getAllParticipantLabels = void 0;
const Schedule_1 = require("./Schedule");
const mergeBy_1 = require("../util/mergeBy");
const getAllParticipantLabels = () => ["student", "class", "teacher", "room"];
exports.getAllParticipantLabels = getAllParticipantLabels;
const getDefaultParticipantLean = () => ({
    text: "",
    isActive: false,
    labels: [],
});
exports.getDefaultParticipantLean = getDefaultParticipantLean;
const getDefaultParticipant = () => ({
    text: "",
    originalHref: "",
    originalScheduleURI: Schedule_1.getSpecificScheduleURI(""),
    labels: [],
});
exports.getDefaultParticipant = getDefaultParticipant;
const mergeStrat = (left, right) => (Object.assign(Object.assign({}, left), { labels: [...new Set([...left.labels, ...right.labels])] }));
exports.mergeDuplicateParticipantsInLessons = mergeBy_1.mergeBy("text", mergeStrat);
const participantHasLesson = (participant) => (lesson) => lesson.students.includes(participant.text) ||
    lesson.classes.includes(participant.text) ||
    lesson.teachers.includes(participant.text) ||
    lesson.rooms.includes(participant.text);
exports.participantHasLesson = participantHasLesson;
const findParticipantsWithMultipleLessonsInSameTime = (participants, lessons) => {
    const dupes = {};
    participants.forEach((participant) => {
        dupes[participant.text] = {};
        lessons.filter(exports.participantHasLesson(participant)).forEach((lesson) => {
            const dayTimeId = [lesson.timeIndex, lesson.dayIndex].join("/");
            if (!dupes[participant.text][dayTimeId]) {
                dupes[participant.text][dayTimeId] = [];
            }
            dupes[participant.text][dayTimeId].push(lesson);
        });
        const confirmedDuplicates = Object.entries(dupes[participant.text]).filter(([_key, duplicateLessons]) => duplicateLessons.length > 1);
        if (confirmedDuplicates.length === 0) {
            delete dupes[participant.text];
        }
        else {
            dupes[participant.text] = Object.fromEntries(confirmedDuplicates);
        }
    });
    return dupes;
};
exports.findParticipantsWithMultipleLessonsInSameTime = findParticipantsWithMultipleLessonsInSameTime;
//# sourceMappingURL=Participant.js.map